module.exports = __webpack_public_path__ + "media/src/images/logos/mass-media/people-434758d70ffdb61fd31877e2d5086b4f.png";